import React from "react";

export const MICROGRIDS_PAGE_TITLE = "Microgrids";

function formatDate(dateStr) {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

function formatRelativeTime(dateStr) {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;

  const now = new Date();
  const diffMs = now - d;
  if (diffMs < 0) return formatDate(dateStr);

  const SEC = 1000;
  const MIN = 60 * SEC;
  const HR = 60 * MIN;
  const DAY = 24 * HR;

  if (diffMs < MIN) return "Just now";
  if (diffMs < HR) return `${Math.floor(diffMs / MIN)}m ago`;
  if (diffMs < DAY) return `${Math.floor(diffMs / HR)}h ago`;
  if (diffMs < 2 * DAY) return "Yesterday";
  if (diffMs < 7 * DAY) return `${Math.floor(diffMs / DAY)}d ago`;
  if (diffMs < 14 * DAY) return "Last week";
  if (diffMs < 30 * DAY) return `${Math.floor(diffMs / (7 * DAY))}w ago`;
  if (diffMs < 365 * DAY) return `${Math.floor(diffMs / (30 * DAY))}mo ago`;
  return formatDate(dateStr);
}

const secondaryStyle = { color: "#64748b", fontSize: "13px" };

export const microgridTableColumns = [
  {
    key: "displayName",
    header: "Microgrid Name",
    render: (row) => (
      <span style={{ fontWeight: 600, fontSize: "15px", color: "#1e293b" }}>
        {row.displayName}
      </span>
    ),
  },
  {
    key: "created",
    header: "Created",
    hideBelow: "xxl",
    width: "150px",
    render: (row) => (
      <span title={formatDate(row.created)} style={secondaryStyle}>
        {formatRelativeTime(row.created)}
      </span>
    ),
  },
  {
    key: "lastAccessed",
    header: "Last Active",
    hideBelow: "lg",
    width: "150px",
    render: (row) => (
      <span title={formatDate(row.lastAccessed)} style={secondaryStyle}>
        {formatRelativeTime(row.lastAccessed)}
      </span>
    ),
  },
  {
    key: "meterName",
    header: "Meter",
    hideBelow: "xxl",
    width: "150px",
    render: (row) => (
      <span style={secondaryStyle}>{row.meterName ?? "-"}</span>
    ),
  },
  {
    key: "deviceDisplay",
    header: "Devices",
    align: "center",
    hideBelow: "md",
    width: "100px",
    render: (row) => {
      const count = row.deviceCount;
      const display = typeof count === "number" && count > 0 ? count - 1 : 0;
      return <span style={secondaryStyle}>{display}</span>;
    },
  },
];
